<template>
  <ul
    class="nav nav-set nav-set-tri"
    :class="$style.tablist"
  >
    <li
      v-for="tab in tabs"
      :key="tab.id"
      :class="[
        $style.item,
        (tab.id === currentTab) && $style.active
      ]"
      @click="handleTabClick(tab.id)"
    >
      <button :class="$style.button">
        {{ tab.name }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    currentTab: {
      type: String,
      default: null,
    },
  },
  created() {
    this.$emit('update:tab', this.$route.query?.tab || 'donationRecord');
  },
  methods: {
    handleTabClick(tabId) {
      this.$emit('update:tab', tabId);
    },
  },
};
</script>

<style lang="scss" module>
.tablist {
  display: flex;
  list-style: none;
  justify-content: flex-start;
  padding: 0;
  margin: 0 auto 20px;
  box-shadow: 0 0 black;
  flex-wrap: wrap;
  user-select: none;
}

.item {
  border-bottom: 3px solid #d8d8d8;
  padding: 1em;
  cursor: pointer;
  color: #d8d8d8;
  transition: 0.1s;
  flex: 1;
  text-align: center;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mobile() {
    padding: 0.5em;
  }

  .button {
    border: none;
    background: transparent;
    color: #d8d8d8;
    padding: 0;
  }

  &.active {
    border-color: #e0556e;

    .button {
      color: #000;
    }
  }
}
</style>
